import React from "react";
import Freshworks from "./Freshworks";
import Shortcode from "./Shortcode";
const EmbedBody = ({ embedType }) => {
	return <>{embedType == "shortcode" ? <Shortcode /> : <Freshworks />}</>;
};

export default EmbedBody;
